"use strict";
// Custom data: metafields (typed values on products, orders, pages, the app…)
// and metaobjects (owner-defined content types with entries: team members,
// menu items, FAQs, events). Contract: @dunea/plugin-sdk primitives/data.ts.
//
//   owner (Content panel, Custom fields cards) ─┐
//   Dunea AI (define_metaobject, upsert_…)     ─┼─▶ studio data ◀── Plugin API (data:read / data:write, own namespace)
//   marketplace install (manifest `data`)       ─┘       │
//                                                         ▼
//   site ─▶ useMetaobjects / useMetafield (public definitions, active entries only)
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_PLUGIN = void 0;
exports.DATA_PLUGIN = {
    id: 'data',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Custom content',
    description: 'Content types the owner edits without code (team, menu, FAQ, events) and custom fields on products, orders and pages.',
    icon: 'i-ph:database',
    surfaces: ['web-app'],
    agentCard: 'Custom content: repeatable content (team, menu, FAQ, testimonials, events) lives in metaobjects the owner edits in the Content panel — define_metaobject + upsert_metaobject_entries, read with useMetaobjects (skills/data.md). Never hardcode lists the owner will update.',
    // Creates a marketplace install's manifest `data` declarations when it activates.
    subscribes: ['marketplace.install.activated'],
    permissions: ['db:own-tables'],
    targets: {
        'web-app': {
            skills: ['data'],
            lockedPaths: ['frontend/worker/dunea/data.ts', 'frontend/src/dunea/data.tsx'],
            // The shared fetch/proxy runtime lives in payments' files.
            uses: ['frontend/worker/dunea/plugins-proxy.ts', 'frontend/src/dunea/payments.tsx'],
            detect: ['registerDataRoutes'],
            budgetGzipKb: 6,
        },
    },
};
